import { RouteObject } from "react-router-dom";
import SettingsRouteList from "./routeList";
import PrivateRoute from "../Authentication/component/PrivateRoute";
import { lazy } from "react";
import userManagementRoutes from "./UserManagement";
import Loader from "../utilis/component/SkeletonLoading/Loader";
const BackUp = lazy(() => import("./BackUp/index"));
const UserList = lazy(()=>import("./User"))
const PostOfficeList=lazy(()=>import("./PostOffice/index"))
const AddOrEditPage=lazy(()=>import("./PostOffice/AddOrEditPage"))
const UserAddOrEditPage=lazy(()=>import("./User/AddOrEdit"))
const UserGroup=lazy(()=>import("./UserGroup/index")) 
const ClinicManagemant = lazy(()=>import("./CinicManagement"))
// const AddOrEditClinic =lazy(()=> import("./CinicManagement/AddOrEditClinic"));
const ExpenseManager=lazy(() => import("./Expense/index"));
const AddOrEditExpense = lazy(() => import("./Expense/AddOrEditPage"));
const FeedbackListPage = lazy(() => import("../PatientFeedback/FeedbackListPage"));


export const SettingsRoutes: RouteObject[] = [
  {
    path: SettingsRouteList.postOffice,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <PostOfficeList/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path:SettingsRouteList.addOrEdit,
        element:(
          <PrivateRoute>
            <Loader>
              <AddOrEditPage />
            </Loader>
          </PrivateRoute>
        )
      }
    ],
  },
  {
    path: SettingsRouteList.userList,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <UserList/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path:SettingsRouteList.addOrEdit,
        element:(
          <PrivateRoute>
            <Loader>
              <UserAddOrEditPage />
            </Loader>
          </PrivateRoute>
        )
      }
    ],
  },
  {
    path: SettingsRouteList.userGroup,
    element: (
      <PrivateRoute>
        <Loader>
          <UserGroup/>
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: SettingsRouteList.BackUp,
    element: (
      <PrivateRoute>
        <Loader>
          <BackUp/>
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path: SettingsRouteList.clinicManagement,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <ClinicManagemant/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path:SettingsRouteList.addOrEdit,
        element:(
          <PrivateRoute>
            <Loader>
              <>Test</>
              {/* <AddOrEditClinic /> */}
            </Loader>
          </PrivateRoute>
        )
      }
    ],
  },
  {
    path: SettingsRouteList.expenseManager,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <ExpenseManager/>
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path:SettingsRouteList.addOrEdit,
        element:(
          <PrivateRoute>
            <Loader>
              <AddOrEditExpense />
            </Loader>
          </PrivateRoute>
        )
      }
    ],
  },
  {
    path: SettingsRouteList.feedbackList,
    element: (
      <PrivateRoute>
        <Loader>
          <FeedbackListPage />
        </Loader>
      </PrivateRoute>
    ),
  },
  {
    path:SettingsRouteList.userManageMent,
    children:userManagementRoutes
  },
];